import { v4 as uuidv4 } from 'uuid'
import crypto from 'crypto'

export const generateMD5Hash = () => {
  const uniqueId = uuidv4()
  const md5Hash = crypto.createHash('md5').update(uniqueId).digest('hex')
  return md5Hash
}
